import _ from 'lodash'
import { withCompInfo } from '../../core/withCompInfo'
import { Tpa3DGalleryDefinition, Tpa3DGalleryProps, Tpa3DGalleryPropsCarmiData, Tpa3DGalleryCSSVars } from './types'
import { getUrl } from '../../tpaGallery'
import { TPAGallerySdkData } from '../../tpaGallery/types'

export const props = withCompInfo<Tpa3DGalleryProps, Tpa3DGalleryDefinition, Tpa3DGalleryPropsCarmiData>(
	['compId', 'compProps', 'viewMode', 'language', 'topology', 'mainPageId', 'globalImageQuality'],
	({ compId, compProps, viewMode, language, topology, mainPageId, globalImageQuality }, carmiProps) => {
		const { images } = carmiProps
		const santaBase = '1.11596.0' // TODO: https://github.com/wix-private/thunderbolt/pull/10592#discussion_r456869411
		return {
			componentReady: false,
			currentIndex: 0,
			images,
			mainPageId,
			quality: _.pick(globalImageQuality, 'unsharpMask'),
			compProps,
			url: getUrl(
				`${topology.scriptsUrl}/services/santa/${santaBase}/node_modules/santa-galleries/target/Slicebox/Slicebox.html`,
				compId,
				viewMode,
				language
			),
		}
	}
)

export const sdkData = withCompInfo<TPAGallerySdkData, Tpa3DGalleryDefinition>(['compData'], ({ compData }) => {
	return {
		dataId: compData.id,
	}
})

export const css = withCompInfo<Tpa3DGalleryCSSVars, Tpa3DGalleryDefinition>(['compLayout'], ({ compLayout }) => ({
	'--height': `${compLayout.height}px`,
}))
